// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  useEmulators: false,
  useAppEngineLocal: false,
  appEngineURL: 'https://jabil-akiba-dev.uc.r.appspot.com',
  appEngineURLLocal: 'http://localhost:8081',
  firebase: {
    apiKey: "AIzaSyBg40uywKT9HhMFP_VCzKYvJDahHz85jDw",
    authDomain: "jabil-akiba-dev.firebaseapp.com",
    databaseURL: "https://jabil-akiba-dev-default-rtdb.firebaseio.com",
    projectId: "jabil-akiba-dev",
    storageBucket: "jabil-akiba-dev.appspot.com",
    messagingSenderId: "1044691264073",
    appId: "1:1044691264073:web:ccae7ca7dcf3d7abef1598",
    measurementId: "G-L60XRNY66W"
  },
  akibaOKTAProd: {
    authority: 'https://dev-16728286.okta.com',
    clientId: '0oa4znxg0tRoHIVZP5d7',
    redirectUri: 'https://jabil-akiba.web.app/account/okta/callback',
    postLogoutRedirectUri: 'https://jabil-akiba.web.app'
  },
  oktaJabilProd: {
    authority: 'https://jabil.okta.com',
    clientId: '0oaijsthev7leod1b2p7',
    redirectUri: 'https://jabil-akiba.web.app/account/okta/callback',
    postLogoutRedirectUri: 'https://jabil-akiba.web.app',
  },
  oktaJabilDev: {
    authority: 'https://jabildev.oktapreview.com',
    clientId: '0oa1cnorh0qBbhvkS0h8',
    redirectUri: 'https://jabil-akiba-dev.web.app/account/okta/callback',
    postLogoutRedirectUri: 'https://jabil-akiba-dev.web.app'
  },
  akibaOKTADev: {
    authority: 'https://dev-16728286.okta.com',
    clientId: '0oa4znxg0tRoHIVZP5d7',
    redirectUri: 'https://jabil-akiba-dev.web.app/account/okta/callback',
    postLogoutRedirectUri: 'https://jabil-akiba-dev.web.app'
  },
  oktaJabilStage: {},
  akibaOKTAStage: {},
  akibaOKTALocal: {
    authority: 'https://dev-16728286.okta.com',
    clientId: '0oa4znxg0tRoHIVZP5d7',
    redirectUri: 'http://localhost:4200/account/okta/callback',
    postLogoutRedirectUri: 'http://localhost:4200'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
